import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import staticAllowedEmails from "./staticAllowedEmails.json";

export const getAdminEmails = async () => {
  try {
    const snapshot = await getDocs(collection(db, "allowedEmails"));
    const firestoreEmails = snapshot.docs.map((doc) => doc.id);

    return Array.from(new Set([...staticAllowedEmails, ...firestoreEmails]));
  } catch (error) {
    console.error("Error fetching allowed emails from Firestore:", error);
    return staticAllowedEmails; // fallback to static list
  }
};
